/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Living_Room_With_DiningInputs */

const cs_enum_living_room_with_dining = /** @type {(inputs: Enum_Living_Room_With_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obývák s jídelnou`)
};

const en_enum_living_room_with_dining = /** @type {(inputs: Enum_Living_Room_With_DiningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Living room with dining`)
};

/**
* | output |
* | --- |
* | "Living room with dining" |
*
* @param {Enum_Living_Room_With_DiningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_living_room_with_dining = /** @type {((inputs?: Enum_Living_Room_With_DiningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Living_Room_With_DiningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_living_room_with_dining(inputs)
	return cs_enum_living_room_with_dining(inputs)
});